import React, { useEffect, useState } from "react";
import "./footer.css";
import fondo from "../../assets/img/Vector.svg";
import fondoMov from "../../assets/img/Vector_movil.svg";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import BtnScroll from "../../components/btn_Scroll/BtnScroll";

const Footer = () => {
  const [lang, setLang] = useState(localStorage.getItem("language") || "es");
  const [t, i18n] = useTranslation("footer");

  const year = new Date().getFullYear();

  return (
    <>
      <BtnScroll />
      <div class="footer-pre">
        <footer className="escritorio">
          <br />
          <div className="row1F ">
            <div className="div1 div_contenedor marg_top  row--border">
              <div className="div1 ">
                <img
                  className="img maxi_logo_rbs"
                  src="https://www.ricardosalinas.com/Content/assets/img/Logo RS.svg"
                  alt="log RBS"
                />
              </div>
              <div className="div3">
                <p className="derechos">
                  <b>
                    {t("footer.derec")} <br />
                    {t("footer.nombre")} <br />
                    {/* <a className="aviso" target="_blank" href="#">Aviso de privacidad</a> */}
                    <a
                      className="aviso"
                      target="_blank"
                      href={t("footer.prueba-liga")}
                    >
                      {t("footer.priva")}
                    </a>
                  </b>
                </p>
              </div>
            </div>
            <div className="div2 div_contenedor marg_top row--border ">
              {/* <div className="div2 contacto">CONTACTO</div> */}
              <div className="div2 contacto">{t("footer.contact")}</div>
              <div className="div3">
                <p className="datos">
                  <br />
                  <b>
                    comentarios.ricardosalinas@gruposalinas.com.mx <br />
                    <br />
                    Periférico Sur #4277 piso 8, Col. Jardines de la <br />
                    Montaña, Tlalpan, 14210 CDMX, México
                  </b>
                </p>
              </div>
            </div>
            <div className="div3 div_contenedor marg_top row--border ">
              <div className="div2">
                <div className="pararow">
                  <div className="div2 especial">
                    <a
                      href="https://www.centroricardobsalinaspliego.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        className="img maxi_logo_centro"
                        src="https://www.ricardosalinas.com/Content/assets/img/centro.svg"
                        alt="log centro"
                      ></img>
                    </a>
                  </div>
                  <div className="div3">
                    <a
                      href="https://www.ulibertad.edu.mx/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        className="img maxi_logo_univ"
                        src="https://www.ricardosalinas.com/Content/assets/img/universidad.svg"
                        alt="log universidad"
                      ></img>
                    </a>
                  </div>
                </div>
              </div>
              <div className="div3 grupo">
                <a
                  href="https://www.gruposalinas.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="img maxi_logo_gs"
                    src="https://www.ricardosalinas.com/Content/assets/img/grupo.svg"
                    alt="log grupo"
                  ></img>
                </a>
              </div>
            </div>
          </div>

          <div className="fondo">
            <img className="img" src={fondo} alt="" />
          </div>
        </footer>

        <footer className="movil">
          {/* movil mas chiquito */}
          <div className="movil div_contenedor_mov">
            {/* <div className="div1_mov div_contenedor_mov "> */}
            <div className="div1_mov ">
              <div className="div1Mov derechos ">
                <img
                  className="img maxi_logo_rbs"
                  src="https://www.ricardosalinas.com/Content/assets/img/Logo RS.svg"
                  alt="log RBS"
                />
              </div>
            </div>
            <div className="div2Mov">
              <p className="derechos">
                <b>
                  {t("footer.priva")}
                  <br />
                  Ricardo Salinas
                  <br />
                  <a
                    className="aviso"
                    target="_blank"
                    href={t("footer.prueba-liga")}
                  >
                    {t("footer.derec")}
                  </a>
                </b>
              </p>
            </div>
            <div className="footerMovilContainer">
              <p className="derechos">
                <b>
                  <a
                    className="aviso"
                    href={t("footer.prueba-liga")}
                    target="_blank"
                  >
                    {t("footer.derecMobile_1")}
                  </a>
                  <br />
                  {t("footer.derecMobile_2")} Ricardo Salinas
                  <br />
                  <a target="_blank" href={t("footer.prueba-liga")}>
                    <span className="avisoPrivacidad">{t("footer.priva")}</span>
                  </a>
                </b>
              </p>
            </div>
            <div className="div3Mov ">
              <div className="contacto">{t("footer.contact")}</div>
            </div>
            <div className="div4Mov">
              <p className="datos correo">
                comentarios.ricardosalinas@gruposalinas.com.mx
              </p>
              <p className="datos">
                Periférico Sur #4277 piso 8, Col. Jardines de la Montaña,
                Tlalpan, 14210 CDMX, México
              </p>
            </div>

            <div className="div5Mov">
              <div className="col1_mov">
                <a
                  href="https://www.centroricardobsalinaspliego.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="img_mov"
                    src="https://www.ricardosalinas.com/Content/assets/img/centro.svg"
                    alt="log centro"
                  />
                </a>
              </div>
              <div className="col2_mov">
                <a
                  href="https://www.ulibertad.edu.mx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="img_mov"
                    src="https://www.ricardosalinas.com/Content/assets/img/universidad.svg"
                    alt="log universidad"
                  />
                </a>
              </div>
            </div>
            <div className="div6Mov">
              <a
                href="https://www.gruposalinas.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="img_mov_gs"
                  src="https://www.ricardosalinas.com/Content/assets/img/grupo.svg"
                  alt="log grupo"
                />
              </a>
            </div>
          </div>
          <div className="fondo">
            <img className="img" src={fondoMov} alt="" />
          </div>
        </footer>
      </div>
    </>
  );
};
export default Footer;
